import { RouteObject } from "react-router-dom";
import SessionBoundary from "../SessionBoundary";
import ValidateUUID from "../ValidateUUID";
import IsolatedCallRedirect from "./IsolatedCallRedirect.tsx";
import IsolatedCallScreen from "./IsolatedCallScreen.tsx";
import TestSoundVideoScreen from "./TestSoundVideoScreen.tsx";
import VideoCallScreen from "./VideoCallScreen";

const CallRoutes: RouteObject = {
  children: [
    // We have both a public version and a logged version of the test sound and video screen
    {
      path: "/test-devices",
      element: <TestSoundVideoScreen standalone={true} />,
    },
    {
      path: "/isolated-call/:token",
      element: <IsolatedCallRedirect />,
    },
    {
      path: "/isolated-call",
      element: <IsolatedCallScreen />,
    },
    {
      path: "/test-lobby",
      element: (
        <SessionBoundary>
          <TestSoundVideoScreen />
        </SessionBoundary>
      ),
    },
    {
      path: "/call/:id",
      element: (
        <SessionBoundary>
          <ValidateUUID>
            <VideoCallScreen />
          </ValidateUUID>
        </SessionBoundary>
      ),
    },
  ],
};

export default CallRoutes;
